import { gql } from 'graphql-request';
import { MagicJobFragment } from './MagicJobFragment';

export const ChatFragment = gql`
  ${MagicJobFragment}
  fragment MagicChat on Chat {
    id
    createdAt
    updatedAt
    events {
      ...MagicEvent
    }
    jobs {
      ...MagicJob
    }
    messages
    experienceId
    experiencePublishedUrl
  }
`;
